var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotijaoP5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 36,
    viewBox: "0 0 24 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1356.651 -2174.677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1356.651 2175.677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 0)",
    fill: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.49960041046143 27.49979972839355 L 2.499900102615356 27.49979972839355 L 2.499900102615356 18.78630065917969 C 2.930404663085938 19.13723945617676 3.479565143585205 19.347900390625 4.077000141143799 19.347900390625 L 9.923399925231934 19.347900390625 C 10.52041435241699 19.347900390625 11.06923198699951 19.13752746582031 11.49960041046143 18.78703308105469 L 11.49960041046143 27.49979972839355 Z M 2.499900102615356 2.879400014877319 L 2.499900102615356 0.5001004338264465 L 11.49960041046143 0.5001004338264465 L 11.49960041046143 2.878667116165161 C 11.06923198699951 2.528172731399536 10.52041435241699 2.317800521850586 9.923399925231934 2.317800521850586 L 4.077000141143799 2.317800521850586 C 3.479565143585205 2.317800521850586 2.930404663085938 2.528461217880249 2.499900102615356 2.879400014877319 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.999600410461426 25.99979972839355 L 9.999600410461426 20.8471851348877 C 9.974268913269043 20.84766006469727 9.948843002319336 20.847900390625 9.923399925231934 20.847900390625 L 4.077000141143799 20.847900390625 C 4.051288604736328 20.847900390625 4.025497913360596 20.84765434265137 3.999900102615356 20.84716796875 L 3.999900102615356 25.99979972839355 L 9.999600410461426 25.99979972839355 M 11.99970054626465 28.99979972839355 L 1.999800086021423 28.99979972839355 C 1.448450088500977 28.99979972839355 0.9999001622200012 28.55125045776367 0.9999001622200012 27.99990081787109 L 0.9999001622200012 4.089355343239731e-07 C 0.9999001622200012 -0.5513495802879333 1.448450088500977 -0.9998995661735535 1.999800086021423 -0.9998995661735535 L 11.99970054626465 -0.9998995661735535 C 12.55105018615723 -0.9998995661735535 12.99960041046143 -0.5513495802879333 12.99960041046143 4.089355343239731e-07 L 12.99960041046143 27.99990081787109 C 12.99960041046143 28.55125045776367 12.55105018615723 28.99979972839355 11.99970054626465 28.99979972839355 Z M 4.077000141143799 3.817800521850586 C 3.525650024414062 3.817800521850586 3.077100038528442 4.266350269317627 3.077100038528442 4.817700386047363 L 3.077100038528442 16.84799957275391 C 3.077100038528442 17.39935111999512 3.525650024414062 17.847900390625 4.077000141143799 17.847900390625 L 9.923399925231934 17.847900390625 C 10.47475051879883 17.847900390625 10.92329978942871 17.39935111999512 10.92329978942871 16.84799957275391 L 10.92329978942871 4.817700386047363 C 10.92329978942871 4.266350269317627 10.47475051879883 3.817800521850586 9.923399925231934 3.817800521850586 L 4.077000141143799 3.817800521850586 Z",
    stroke: "none",
    fill: "#000FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6)",
    fill: "#000FFF",
    stroke: "#000FFF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 25,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 30)",
    fill: "#000FFF",
    stroke: "#000FFF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 5,
    rx: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 4,
    rx: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H17.073",
    transform: "translate(1360.296 2194.476)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotijaoP5);
export default __webpack_public_path__ + "static/media/botijao-p5.dc4dd43e5eac4e7e78b1d1b7b3db2294.svg";
export { ForwardRef as ReactComponent };